// extracted by mini-css-extract-plugin
module.exports = {"doctor-review__title":"doctor-review_doctor-review__title__2CYsE","doctor-review__profile":"doctor-review_doctor-review__profile___HIaB"};